<template>
    <modal :show="show.value" modal-classes="modal-xl modal-dialog-scrollable" :show-close="true" @close="closeModal">
        <template v-slot:header>
            <h5 class="modal-title" id="exampleModalLabel">Neues Dokument zu diesem Standort hinzufügen</h5>
        </template>
        <location-document-form ref="locationdocumentform" :location="'/api/locations/'+location" @locationDocumentCreated="closeModal"></location-document-form>

    </modal>
</template>

<script>

    import LocationDocumentForm from "@/views/LocationDocuments/Form";
    export default {
        name:"LocationDocumentModal",
        components:{LocationDocumentForm},
        props: {
            show: {
                type: Object,
                default: () => { return {value: false }}
            },
            location: {
                default: null
            }
        },
        data() {
            return {

            }
        },
        methods: {
            closeModal() {
                this.show.value = false;
                this.$emit("modalClosed");
            }
        }
    }
</script>

<style scoped>

</style>